import { useState } from 'react'
import { Link } from 'react-router-dom'
import { goldGradientButtonSm, outlineButtonCta } from '@/lib/brandGradient'

const COOKIE_KEY = 'vaagon-cookie-consent'

type Choice = 'accepted' | 'declined' | 'dismissed'

function readBannerOpen(): boolean {
  return !window.localStorage.getItem(COOKIE_KEY)
}

export function CookieConsentBanner() {
  const [open, setOpen] = useState(readBannerOpen)

  const decide = (choice: Choice) => {
    window.localStorage.setItem(COOKIE_KEY, choice)
    setOpen(false)
  }

  if (!open) return null

  return (
    <div className="fixed right-4 bottom-4 left-4 z-[120] sm:left-auto sm:max-w-[560px]">
      <div className="relative rounded-2xl border border-black/10 bg-white p-4 pr-10 shadow-[0_20px_50px_-22px_rgba(0,0,0,0.2)] ring-1 ring-black/5 backdrop-blur dark:border-white/10 dark:bg-[#0f0f10] dark:shadow-[0_20px_50px_-22px_rgba(0,0,0,0.7)] dark:ring-white/8">
        <button
          type="button"
          onClick={() => decide('dismissed')}
          aria-label="Dismiss cookie banner"
          className="absolute top-2 right-2 grid h-7 w-7 place-items-center rounded-full text-black/45 transition hover:bg-black/6 hover:text-black dark:text-white/55 dark:hover:bg-white/10 dark:hover:text-white"
        >
          <svg aria-hidden className="h-4 w-4" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 6l12 12M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <h2 className="pr-2 text-base font-medium text-[#0A0A0A] dark:text-white">
          Cookie Policy
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-[#0A0A0A]/85 dark:text-white/85">
          We use cookies to enhance your experience and analyze traffic. Accept
          or decline. See our{' '}
          <Link
            to="/cookies"
            className="font-medium text-[#B6761E] underline-offset-2 hover:text-[#9A6115] hover:underline dark:text-[#E0A263] dark:hover:text-[#F6CB86]"
          >
            Cookie Policy
          </Link>
          .
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => decide('accepted')}
            className={`inline-flex h-9 items-center justify-center px-4 text-sm font-semibold ${goldGradientButtonSm}`}
          >
            Accept
          </button>
          <button
            type="button"
            onClick={() => decide('declined')}
            className={`h-9 px-4 text-sm font-semibold text-white ${outlineButtonCta}`}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  )
}
